import {
  format,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";

/**
 * Resolves a quick filter preset ("daily" | "weekly" | "monthly" | "yearly")
 * to a {from, to} pair of "yyyy-MM-dd" strings anchored on today. Returns
 * null for "custom" (caller keeps whatever from/to is already set).
 */
export function resolveDateRangePreset(type) {
  const today = new Date();
  let start, end;

  switch (type) {
    case "daily":
      start = startOfDay(today);
      end = endOfDay(today);
      break;
    case "weekly":
      start = startOfWeek(today);
      end = endOfWeek(today);
      break;
    case "monthly":
      start = startOfMonth(today);
      end = endOfMonth(today);
      break;
    case "yearly":
      start = startOfYear(today);
      end = endOfYear(today);
      break;
    default:
      return null;
  }

  return { from: format(start, "yyyy-MM-dd"), to: format(end, "yyyy-MM-dd") };
}
